import { Theme } from '@mui/material';
import { SettingsFields } from '@bandido/shared/types';

export const stringToAvatar = (name: string) => `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;

export function compact<T>(array: T[]): T[] {
  return array?.filter((item) => Boolean(item)) || [];
}

export function unique<T>(array: T[]): T[] {
  return [...new Set(array)];
}

export const getContrastYIQ = (theme: Theme, hexcolor?: string): string => {
  if (!hexcolor) {
    return theme.palette.text.primary;
  }
  const color = hexcolor.replace('#', '');

  // convert to rgb
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  // Calcular YIQ???
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? theme.palette.text.primary : theme.palette.common.white;
};

export const addLeadingZeros = (number: number, finalLength: number) => {
  const numStr = String(number);
  let zerosToAdd = finalLength - numStr.length;
  zerosToAdd = Math.max(0, zerosToAdd);

  return '0'.repeat(zerosToAdd) + numStr;
};

export function isSettingSensitive(setting: SettingsFields) {
  return [
    SettingsFields.WHATSAPP_OPENAI_API_KEY,
    SettingsFields.AWS_ACCESS_KEY_ID,
    SettingsFields.AWS_SECRET_ACCESS_KEY,
    SettingsFields.GOOGLE_CLIENT_SECRET,
    SettingsFields.JWT_RESET_PASSWORD,
    SettingsFields.JWT_SECRET,
    SettingsFields.TWILIO_API_KEY,
    SettingsFields.TWILIO_API_KEY_SECRET,
    SettingsFields.TWILIO_AUTH_TOKEN,
    SettingsFields.VITE_GOOGLE_KEY,
  ].includes(setting);
}

export const formatTimeDifference = (diffInSeconds: number): string => {
  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);
  const seconds = diffInSeconds % 60;

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  } else {
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
};


  // 1. Normalizar tildes y reemplazar por vocales simples
  // 2. Reemplazar caracteres no alfanuméricos ni espacio por wildcard x
  // 3. Reducir múltiples espacios a uno solo
  // 4. Trim para evitar espacios al principio o final
  // 5. Reemplazar espacios por guiones bajos
export function escapeFilename(input: string): string {
  let output = input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\s._]/g, 'x')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/ /g, '_');

  return output;
}
